import { z } from "zod";

// Schema for arbre_nuisible relation
export const ArbreNuisibleBaseSchema = z.object({
  arbre_id: z.number().int().positive("L'ID de l'arbre doit être un nombre positif"),
  nuisible_id: z.number().int().positive("L'ID du nuisible doit être un nombre positif"),
});

export const ArbreNuisibleSchema = ArbreNuisibleBaseSchema;

export const ArbreNuisibleCreateSchema = ArbreNuisibleBaseSchema.pick({
  arbre_id: true,
  nuisible_id: true,
});

export const ArbreNuisibleDeleteSchema = ArbreNuisibleBaseSchema;

export const ArbreNuisibleListResponseSchema = z.object({
  data: z.array(ArbreNuisibleSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});

export const ArbreNuisibleResponseSchema = z.object({
  data: ArbreNuisibleSchema,
  message: z.string().optional(),
});

export const ArbreNuisibleSelectSchema = z.object({
  arbre_id: z.number().int().positive().optional(),
  nuisible_id: z.number().int().positive().optional(),
});

// Schema for history_nuisible relation
export const HistoryNuisibleBaseSchema = z.object({
  history_id: z.number().int().positive("L'ID de l'historique doit être un nombre positif"),
  nuisible_id: z.number().int().positive("L'ID du nuisible doit être un nombre positif"),
});

export const HistoryNuisibleSchema = HistoryNuisibleBaseSchema;

export const HistoryNuisibleCreateSchema = HistoryNuisibleBaseSchema.pick({
  history_id: true,
  nuisible_id: true,
});

export const HistoryNuisibleDeleteSchema = HistoryNuisibleBaseSchema;

export const HistoryNuisibleListResponseSchema = z.object({
  data: z.array(HistoryNuisibleSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});

export const HistoryNuisibleResponseSchema = z.object({
  data: HistoryNuisibleSchema,
  message: z.string().optional(),
});

export const HistoryNuisibleSelectSchema = z.object({
  history_id: z.number().int().positive().optional(),
  nuisible_id: z.number().int().positive().optional(),
});

// Schema for history_docs
export const HistoryDocsBaseSchema = z.object({
  path: z.string().max(255, "Le chemin ne peut pas dépasser 255 caractères").nullable().optional(),
  history_id: z.number().int().positive("L'ID de l'historique doit être un nombre positif").nullable().optional(),
});

export const HistoryDocsSchema = HistoryDocsBaseSchema.extend({
  id: z.number().int().positive(),
});

export const HistoryDocsCreateSchema = HistoryDocsBaseSchema.pick({
  path: true,
  history_id: true,
});

export const HistoryDocsUpdateSchema = z.object({
  id: z.number().int().positive(),
  path: z.string().max(255, "Le chemin ne peut pas dépasser 255 caractères").nullable().optional(),
  history_id: z.number().int().positive("L'ID de l'historique doit être un nombre positif").nullable().optional(),
});

export const HistoryDocsListResponseSchema = z.object({
  data: z.array(HistoryDocsSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});

export const HistoryDocsResponseSchema = z.object({
  data: HistoryDocsSchema,
  message: z.string().optional(),
});

export const HistoryDocsSelectSchema = z.object({
  id: z.number().int().positive().optional(),
  history_id: z.number().int().positive().optional(),
  path: z.string().optional(),
});

// Types
export type ArbreNuisible = z.infer<typeof ArbreNuisibleSchema>;
export type ArbreNuisibleCreateInput = z.infer<typeof ArbreNuisibleCreateSchema>;
export type ArbreNuisibleSelectInput = z.infer<typeof ArbreNuisibleSelectSchema>;

export type HistoryNuisible = z.infer<typeof HistoryNuisibleSchema>;
export type HistoryNuisibleCreateInput = z.infer<typeof HistoryNuisibleCreateSchema>;
export type HistoryNuisibleSelectInput = z.infer<typeof HistoryNuisibleSelectSchema>;

export type HistoryDocs = z.infer<typeof HistoryDocsSchema>;
export type HistoryDocsCreateInput = z.infer<typeof HistoryDocsCreateSchema>;
export type HistoryDocsUpdateInput = z.infer<typeof HistoryDocsUpdateSchema>;
export type HistoryDocsSelectInput = z.infer<typeof HistoryDocsSelectSchema>;

// Response types
export type ArbreNuisibleResponse = z.infer<typeof ArbreNuisibleResponseSchema>;
export type ArbreNuisibleListResponse = z.infer<typeof ArbreNuisibleListResponseSchema>;

export type HistoryNuisibleResponse = z.infer<typeof HistoryNuisibleResponseSchema>;
export type HistoryNuisibleListResponse = z.infer<typeof HistoryNuisibleListResponseSchema>;

export type HistoryDocsResponse = z.infer<typeof HistoryDocsResponseSchema>;
export type HistoryDocsListResponse = z.infer<typeof HistoryDocsListResponseSchema>;

// Validation functions
export const validateArbreNuisibleCreate = (data: unknown) => {
  return ArbreNuisibleCreateSchema.safeParse(data);
};

export const validateArbreNuisibleSelect = (data: unknown) => {
  return ArbreNuisibleSelectSchema.safeParse(data);
};

export const validateHistoryNuisibleCreate = (data: unknown) => {
  return HistoryNuisibleCreateSchema.safeParse(data);
};

export const validateHistoryNuisibleSelect = (data: unknown) => {
  return HistoryNuisibleSelectSchema.safeParse(data);
};

export const validateHistoryDocsCreate = (data: unknown) => {
  return HistoryDocsCreateSchema.safeParse(data);
};

export const validateHistoryDocsUpdate = (data: unknown) => {
  return HistoryDocsUpdateSchema.omit({ id: true }).safeParse(data);
};

export const validateHistoryDocsSelect = (data: unknown) => {
  return HistoryDocsSelectSchema.safeParse(data);
};
